export function scoreLabel(score: number | null | undefined, dimension: "discovery" | "mainstream" | "momentum" | "aesthetic" | "confidence"): string {
  if (score == null) return "—";
  if (dimension === "mainstream") {
    if (score >= 75) return "High";
    if (score >= 40) return "Medium";
    return "Low";
  }
  if (score >= 80) return "Strong";
  if (score >= 60) return "High";
  if (score >= 40) return "Medium";
  return "Low";
}

export function priceLevelLabel(level: string | null | undefined): string {
  if (!level) return "—";
  return level
    .split("-")
    .map((s) => s[0]?.toUpperCase() + s.slice(1))
    .join("-");
}
